import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { PainPointsSection } from '../components/sales/PainPointsSection';
import { WhyFailedSection } from '../components/sales/WhyFailedSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { WhatIncludedSection } from '../components/sales/WhatIncludedSection';
import { WhoForSection } from '../components/sales/WhoForSection';
import { TimelineSection } from '../components/sales/TimelineSection';
import { FAQSection } from '../components/sales/FAQSection';
import { FinalCTASection } from '../components/sales/FinalCTASection';
import { Footer } from '../components/sales/Footer';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-white font-sans text-[#3D4852] selection:bg-[#C17F6B]/30" data-id="element-234">
      <HeroSection data-id="element-235" />
      <PainPointsSection data-id="element-236" />
      <WhyFailedSection data-id="element-237" />
      <SolutionSection data-id="element-238" />
      <WhatIncludedSection data-id="element-239" />
      <WhoForSection data-id="element-240" />
      <TimelineSection data-id="element-241" />
      <FAQSection data-id="element-242" />
      <FinalCTASection data-id="element-243" />
      <Footer data-id="element-244" />
    </main>;
}